module.exports = {
  GENERAL: 0,
  ISSUE: 1,
  OUT_FOR_COLLECTION: 2,
  COLLECTED: 3,
};
